import { DETECT_AD_BLOCKER } from 'actions/adBlocker';

const initialState = {
  adBlockerDetected: false,
};

export default function adBlocker(state = initialState, action) {
  switch (action.type) {
    case DETECT_AD_BLOCKER:
      return {
        ...state,
        adBlockerDetected: action.adBlockerDetected,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adBlocker.js